<div class="profile-menu">
  <div class="welcome-user-cont">
    <div class="welcome-info-cont">
      <h1 style="color: #f3f4f6" class="title-h4">Hola, {{ username }}</h1>
      <p class="subtitle-p">Último acceso: {{ lastAccess }}</p>

      <!-- Pulse effect -->
      <div class="licencia-cont">
        @let producerLicence = cotizadoresService.producerLicence();
        <div
          class="pulse-effect"
          [ngClass]="{
            expired: producerLicence.expiredLicence === 'SI',
          }"
        ></div>
        <p
          class="licencia"
          [ngClass]="{
            expired: producerLicence.expiredLicence === 'SI',
          }"
        >
          {{ getLicence() }} -
        </p>
        <p
          class="licencia"
          [ngClass]="{
            expired: producerLicence.expiredLicence === 'SI',
          }"
        >{{ getProducerStatus() }}</p>
      </div>
    </div>
  </div>
  <div class="barra-cont">
    <div class="dropdown">
      <div class="dropdown-container">
        <button
          type="button"
          class="dropdown-button"
          (click)="toggleDropdown($event)"
        >
          <img
            style="width: 22px; height: 22px"
            src="./assets/user-main.svg"
            alt="user"
          />
          <span style="color: #f3f4f6; font-weight: 200; font-size: 15px">{{
            selectedOption || "Perfil"
          }}</span>
          <i
            style="color: #f3f4f6; font-size:15px; "
            class="bi bi-chevron-down"
            [class.rotate]="isOpen"
          ></i>
        </button>
        <div
          style="font-size: 15px"
          class="dropdown-content"
          [class.show]="isOpen"
        >
          @for (option of options; track option) {
          <div
            style="color: #004d80"
            class="dropdown-item"
            (click)="selectOption(option.name)"
            [class.selected]="option.name === selectedOption"
          >
            <img [src]="option.icon" alt="icon" />
            {{ option.name }}
          </div>
          }
        </div>
      </div>
    </div>
    <div class="app-notificacion">
      <app-notification
        [notifications]="notifications"
        (onBellClick)="onBellClick()"
      ></app-notification>
    </div>
  </div>
</div>

<app-modal-salir
  [mostrarModal]="mostrarModalSalir"
  (confirmar)="onConfirmarSalir()"
  (cancelar)="onCancelarSalir()"
></app-modal-salir>

<app-modal-licencia
  [isOpen]="showLicenciaModal"
  [fechaExpiracion]="fechaExpiracion"
  (close)="onCloseLicenciaModal()"
></app-modal-licencia>
